import { InjectionToken, signal } from '@angular/core';
import { Action_Type } from 'gql/graphql';

export const CONTROLS_SUBTITLE = new InjectionToken('controls subtitle', {
  factory: () =>
    signal<{ key: string; params: Record<string, any> }>({
      key: '',
      params: {},
    }),
});

type ActionDetails = {
  label: string;
  defaultMin: { label: string; value: number };
  defaultMax: { label: string; value: number };
  defaultValue: number;
  showAlwaysDefaultLabels: boolean;
};
export type ActionType = Record<Action_Type | string, ActionDetails>;
export const ACTION_TYPE_DICTIONARY = {
  [Action_Type.Temperature]: {
    label: 'Temperature',
    defaultMin: {
      label: '0%',
      value: 0,
    },
    defaultMax: {
      label: '100%',
      value: 100,
    },
    defaultValue: 50,
    showAlwaysDefaultLabels: false,
  },
  [Action_Type.ChargingSpeed]: {
    label: 'Charging Speed',
    defaultMin: {
      label: 'Low',
      value: 0,
    },
    defaultMax: {
      label: 'High',
      value: 3,
    },
    defaultValue: 2,
    showAlwaysDefaultLabels: true,
  },
};
